export default __webpack_public_path__ + "static/media/sidebar-resignation.3d421fa8.png";